import { z } from 'zod';

// SePay is excluded — only reconciliation creates SePay payments.
export const MANUAL_SOURCES = ['CASH', 'MANUAL_BANK', 'ECOMMERCE', 'OTHER'] as const;

export const recordPaymentSchema = z
  .object({
    source: z.enum(MANUAL_SOURCES),
    // 0 is valid: a manual deduction line can bring an invoice's total to
    // exactly zero, and that invoice still needs a way to be marked settled.
    // Negative stays invalid — a payment can't be a negative amount.
    amount: z.number().int().nonnegative(),
    transactionDate: z.string().datetime(),
    content: z.string().max(500).default(''),
    invoiceId: z.string().nullable().optional(),
    invoiceCode: z.string().nullable().optional(),
    clientId: z.string().nullable().optional(),
  })
  .refine(
    (v) => !(v.invoiceId && v.invoiceCode),
    { message: 'Provide either invoiceId or invoiceCode, not both' },
  )
  .refine(
    (v) => !((v.invoiceId || v.invoiceCode) && v.clientId),
    { message: 'clientId is only for ad-hoc payments (no invoice)' },
  );

export type RecordPaymentInput = z.infer<typeof recordPaymentSchema>;

// Links an OPEN (unmatched) payment to an invoice — the unmatched-payments inbox flow.
export const linkPaymentSchema = z.object({
  invoiceId: z.string().min(1),
});

export type LinkPaymentInput = z.infer<typeof linkPaymentSchema>;
